import { useState } from 'react';
import { Button } from '../ui/button';
import { Textarea } from '../ui/textarea';
import { Copy, RefreshCw, ArrowUpDown } from 'lucide-react';
import { toast } from 'sonner';

const SortLinesTool = () => {
  const [input, setInput] = useState('');
  const [sortType, setSortType] = useState('alpha-asc');

  const sortLines = () => {
    if (!input) return '';
    const lines = input.split('\n');
    
    switch (sortType) {
      case 'alpha-asc':
        return lines.sort((a, b) => a.localeCompare(b)).join('\n');
      case 'alpha-desc':
        return lines.sort((a, b) => b.localeCompare(a)).join('\n');
      case 'num-asc':
        return lines.sort((a, b) => parseFloat(a) - parseFloat(b)).join('\n');
      case 'num-desc':
        return lines.sort((a, b) => parseFloat(b) - parseFloat(a)).join('\n');
      case 'length-asc':
        return lines.sort((a, b) => a.length - b.length).join('\n');
      case 'length-desc':
        return lines.sort((a, b) => b.length - a.length).join('\n');
      case 'random':
        return [...lines].sort(() => Math.random() - 0.5).join('\n');
      case 'reverse':
        return [...lines].reverse().join('\n');
      default:
        return input;
    }
  };

  const output = sortLines();

  const copyOutput = () => {
    navigator.clipboard.writeText(output);
    toast.success('Sorted lines copied!');
  };

  return (
    <div className="space-y-6" data-testid="sort-lines-tool">
      <div className="flex gap-2 flex-wrap">
        {[
          { value: 'alpha-asc', label: 'A→Z' },
          { value: 'alpha-desc', label: 'Z→A' },
          { value: 'num-asc', label: '0→9' },
          { value: 'num-desc', label: '9→0' },
          { value: 'length-asc', label: 'Short→Long' },
          { value: 'length-desc', label: 'Long→Short' },
          { value: 'random', label: 'Random' },
          { value: 'reverse', label: 'Reverse Order' },
        ].map((opt) => (
          <Button
            key={opt.value}
            variant={sortType === opt.value ? 'default' : 'outline'}
            onClick={() => setSortType(opt.value)}
            size="sm"
          >
            {opt.label}
          </Button>
        ))}
      </div>

      <div className="grid md:grid-cols-2 gap-4">
        <div>
          <label className="text-sm text-muted-foreground mb-2 block">Input Lines</label>
          <Textarea
            placeholder="Enter lines to sort (one per line)..."
            value={input}
            onChange={(e) => setInput(e.target.value)}
            className="min-h-[250px] font-mono text-sm bg-muted/50"
          />
        </div>
        <div>
          <label className="text-sm text-muted-foreground mb-2 block">Sorted Output</label>
          <Textarea
            value={output}
            readOnly
            className="min-h-[250px] font-mono text-sm bg-muted/50"
          />
        </div>
      </div>

      <div className="flex gap-2">
        <Button onClick={copyOutput} disabled={!output}>
          <Copy className="w-4 h-4 mr-2" /> Copy Result
        </Button>
        <Button onClick={() => setInput(output)} variant="outline" disabled={!output}>
          <ArrowUpDown className="w-4 h-4 mr-2" /> Apply to Input
        </Button>
        <Button onClick={() => setInput('')} variant="outline">
          <RefreshCw className="w-4 h-4 mr-2" /> Clear
        </Button>
      </div>
    </div>
  );
};

export default SortLinesTool;
